export default function rialConvertToToman(amount) {
  return amount / 10;
}
